import Suppliers from '../../views/suppliers/Suppliers.vue'
import Supplier from '../../views/suppliers/Supplier.vue'
import SupplierGeneral from '../../views/suppliers/SupplierGeneral.vue'
import SupplierAttributes from '../../views/suppliers/SupplierAttributes.vue'


import SupplierConversations from '../../views/suppliers/SupplierConversations.vue'
import SupplierProjects from '../../views/suppliers/SupplierProjects.vue'
import SupplierProject from '../../views/suppliers/SupplierProject.vue'
import SupplierProjectAllPeriods from '../../views/suppliers/SupplierProjectAllPeriods.vue'
import SupplierProjectFlowSummary from '../../views/suppliers/SupplierProjectFlowSummary.vue'
import SupplierProjectFlowSummaryAnalysis from '../../views/suppliers/SupplierProjectFlowSummaryAnalysis.vue'
import IntermediateFlowsupplierPage from '../../views/suppliers/IntermediateFlowsupplierPage.vue'


import SupplierUsers from '../../views/suppliers/SupplierUsers.vue'
import SupplierCreateUser from '../../views/suppliers/SupplierCreateUser.vue'
import SupplierUser from '../../views/suppliers/SupplierUser.vue'
import SupplierFlow from '../../views/suppliers/SupplierFlow.vue'
import CreateSupplier from '../../views/brands/CreateSupplier.vue'
import SupplierFlowNonconformity from '../../views/suppliers/SupplierFlowNonconformity.vue'
import NonconformityClosureRequests from '../../views/nonconformityclosurerequests/NonconformityClosureRequests.vue'
import CertificateUploads from '../../views/certificateuploads/CertificateUploads.vue'
import SupplierAdminCards from '../../views/suppliers/SupplierAdminCards.vue'
import SupplierAdmincard from '../../views/suppliers/SupplierAdmincard.vue'
import BeyzayaOzel from '../../views/suppliers/BeyzayaOzel.vue'
import AddAddresses from '../../views/suppliers/AddAddresses.vue'

    import {roleSystemRoute} from './route_utilities'

      export const beyzaya_ozel = {
      path: 'beyzaya_ozel',
      name: 'BeyzayaOzel',  
      component: BeyzayaOzel,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "tedarikci",
          domain:"suppliers",
          accessroles:["admin","brand","auditor","planner"],
        },
      }

      export const add_addresses = {
      path: 'add_addresses',
      name: 'AddAddresses',  
      component: AddAddresses,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "tedarikci",
          domain:"suppliers",
          accessroles:["admin","brand","auditor","planner"],
        },
      }


      export const closurerequests = {
      path: 'closurerequests',
      name: 'NonconformityClosureRequests',  
      component: NonconformityClosureRequests,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "kapatma_talepleri",
          domain:"closurerequests",
          accessroles:["admin","brand","auditor","planner"],
        },
      }

      export const certificate_uploads = {
      path: 'certificate_uploads',
      name: 'CertificateUploads',  
      component: CertificateUploads,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "sertifika_yuklemeleri",
          domain:"certificate_uploads",
          accessroles:["admin","brand","auditor","planner"],
        },
      }

      export const suppliers = {
      path: 'suppliers',
      name: 'Suppliers',  
      component: Suppliers,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "tedarikciler",
          domain:"suppliers",
          accessroles:["admin","brand","auditor","planner"],
        },
      }

export const create_supplier = {
      path: 'new_supplier',  
      name: 'CreateSupplier',
      component: CreateSupplier,
      meta: {
          title: "yeni_tedarikci",
          preloader:true,
          domain:"suppliers"
        },
      }


     export const intermediate_flow_supplier =      {
          path: 'project_intermediate/:flowsupplier_uuid',  
          name: 'IntermediateFlowsupplierPage',
          component: IntermediateFlowsupplierPage,
          meta: {
              title: "asama_ozeti",
              preloader:true,
              domain:"suppliers"
            },
          }
export const supplier =  {
      path: 'supplier/:id',  
      name: 'Supplier',
      component: Supplier,
      beforeEnter : roleSystemRoute,
      redirect: { name: 'SupplierGeneral' },
      meta: {
          title: "tedarikci",
          preloader:true,
          domain:"suppliers",          
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
          {
          path: 'general',  
          name: 'SupplierGeneral',
          component: SupplierGeneral,
          meta: {
              title: "genel",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'attributes',  
          name: 'SupplierAttributes',
          component: SupplierAttributes,
          meta: {
              title: "degiskenler",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'conversations',  
          name: 'SupplierConversations',
          component: SupplierConversations,
          meta: {
              title: "tedarikci_gorusmeleri",
              preloader:true,
              domain:"suppliers"
            },
          },          
         {
          path: 'supplier_cards',  
          name: 'SupplierAdminCards',
          component: SupplierAdminCards,
          meta: {
              title: "Ttedarikci_kartlari",
              preloader:true,
              domain:"supplierbrands"
            },
         },
         {
          path: 'supplier_card/:card_id',  
          name: 'SupplierAdmincard',
          component: SupplierAdmincard,
          meta: {
              title: "Ttedarikci_karti",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'projects',  
          name: 'SupplierProjects',
          component: SupplierProjects,
          meta: {
              title: "projeler",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'project_all_periods/:project_id',  
          name: 'SupplierProjectAllPeriods',
          component: SupplierProjectAllPeriods,
          meta: {
              title: "projeler",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'project/:project_id',  
          name: 'SupplierProject',
          component: SupplierProject,
          meta: {
              title: "proje",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'project/:project_id/summary/:flow_id',  
          name: 'SupplierProjectFlowSummary',
          component: SupplierProjectFlowSummary,
          meta: {
              title: "asama_ozeti",
              preloader:true,
              domain:"suppliers"
            },
          },  

          {
          path: 'project/:project_id/analysis/:flow_id',  
          name: 'SupplierProjectFlowSummaryAnalysis',
          component: SupplierProjectFlowSummaryAnalysis,
          meta: {
              title: "bolum_analizi",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'users',  
          name: 'SupplierUsers',
          component: SupplierUsers,
          meta: {
              title: "yetkililer",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'user',  
          name: 'SupplierCreateUser',
          component: SupplierCreateUser,
          meta: {
              title: "yeni_yetkili",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'user/:user_id?',  
          name: 'SupplierUser',
          component: SupplierUser,
          meta: {
              title: "kullanici_bilgileri",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'flow/:flow_id',  
          name: 'SupplierFlow',
          component: SupplierFlow,
          meta: {
              title: "akis",
              preloader:true,
              domain:"suppliers"
            },
          },
          {
          path: 'nonconformity/:nonconformity_id',  
          name: 'SupplierFlowNonconformity',
          component: SupplierFlowNonconformity,
          meta: {
              title: "uygunsuzluk",
              preloader:true,
              domain:"suppliers"
            },
         },
          ]
      }